import { getAuthHeader } from "../tokenStorage";
import { axiosInstance, noCacheHeaders } from './axiosInstance';

export const addCommit = async (payload) => {
  const { file, programId, commitId, fileName, repositoryId, activitySetId, name, activitySetName } = payload;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", fileName);
  formData.append("programId", programId);
  formData.append("commitId", commitId);
  formData.append("repositoryId", repositoryId);
  formData.append("activitySetId", activitySetId);
  formData.append("name", name);
  formData.append("activitySetName", activitySetName);

  return axiosInstance.post(
    `/blapi/ide/commit`,
    formData,
    {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    }
  ).then((res) => {
    return res;
  });
};

export const getProjectByCommit = async (repositoryId, commitId) => {
  return axiosInstance.get(`/blapi/ide/getProjectByCommit/${repositoryId}/${commitId}`, {
    responseType: 'blob',
    headers: getAuthHeader(),
  });
};

export const getMyRepository = async (payload) => {
  const { programId, activitySetId } = payload;
  const encodedActivitySetId = encodeURIComponent(activitySetId);

  return axiosInstance.get(
    `/blapi/ide/getMyRepository/${programId}/${encodedActivitySetId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getProjectByRepository = async (payload) => {
  const { programId, repositoryId, publicHash } = payload;

  return axiosInstance.get(
    !publicHash ? `/blapi/ide/getProjectByRepository/${programId}/${repositoryId}` :
      `/blapi/ide/getPublicProjectByRepository/${repositoryId}/${publicHash}`
    ,
    {
      responseType: 'blob',
      headers: getAuthHeader(),
    }
  );
};

export const getRepository = async (payload) => {
  const { programId, repositoryId, hash, publicHash } = payload;
  const encodedHash = encodeURIComponent(hash);

  return axiosInstance.get(
    !publicHash ? `/blapi/ide/getRepository/${programId}/${repositoryId}/${encodedHash}` :
      `/blapi/ide/getPublicRepository/${repositoryId}/${encodedHash}/${publicHash}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getIsCommitSaved = async (repositoryId, commitId) => {
  return axiosInstance.get(
    `/blapi/ide/getIsCommitSaved/${repositoryId}/${commitId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};
